"use client";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export default function IC_EN_12({ width, height }) {
  const { theme } = useTheme();
  const [color, setColor] = useState("#324ba6");

  useEffect(() => {
    setColor(theme === "dark" ? "#324BA6" : "#324ba6");
  }, [theme]);
  return (
    <svg
      id="Capa_1"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      width={width}
      height={height}
    >
      <defs>
        <style>
          {` .cls-1 {
        stroke-width: 0px;
        fill: ${color};
      }`}
        </style>
      </defs>
      <path
        className="cls-1"
        d="m1.39,30c-.76,0-1.39-.62-1.39-1.39v-1.81c0-.71.54-1.31,1.25-1.38l.38-.04v-11.38l-.38-.04c-.71-.07-1.25-.66-1.25-1.38v-1.81c0-.76.62-1.39,1.39-1.39h2.75V3.55c0-.76.62-1.39,1.39-1.39h1.59V.48C7.11.22,7.33,0,7.59,0s.48.22.48.48v1.69h1.59c.76,0,1.39.62,1.39,1.39v5.84h7.9V3.55c0-.76.62-1.39,1.39-1.39h1.59V.48C21.93.22,22.14,0,22.41,0s.48.22.48.48v1.69h1.59c.76,0,1.39.62,1.39,1.39v5.84h2.75c.76,0,1.39.62,1.39,1.39v1.81c0,.71-.54,1.31-1.25,1.38l-.38.04v11.38l.38.04c.71.07,1.25.66,1.25,1.38v1.81c0,.76-.62,1.39-1.39,1.39H1.39Zm-.42-.96h27.69l.39-.07v-2.58H.96v2.65Zm1.63-3.61h24.82v-11.45s-24.82,0-24.82,0v11.45ZM.96,13.01h28.07v-2.65H.96v2.65Zm18.95-3.61h4.99v-2.65h-4.99v2.65Zm-14.82,0h4.99v-2.65h-4.99v2.65Zm14.82-3.61h4.99v-2.65h-4.99v2.65Zm-14.82,0h4.99v-2.65h-4.99v2.65Z"
      />
      <path
        className="cls-1"
        d="m15.03,22.76c-.07,0-.13-.01-.19-.04-.24-.1-.36-.39-.25-.63l.82-1.91h-1.55c-.17,0-.31-.08-.4-.22-.09-.14-.1-.31-.03-.46l1.17-2.58c.08-.17.25-.28.44-.28.07,0,.14.01.2.04.24.11.35.4.24.64l-.86,1.9h1.53c.16,0,.31.08.4.22.09.14.11.3.04.46l-1.11,2.58c-.08.18-.25.29-.44.29h0Z"
      />
    </svg>
  );
}
